import React, { PureComponent } from 'react';
import styled from 'styled-components';

const Root = styled.div.withConfig({ componentId: 'sc-1851xas-0' })`
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

type Props = {
  className?: string;
};
class VerticallyAlignedContainer extends PureComponent<Props> {
  render() {
    const { className } = this.props;

    return <Root className={className}>{this.props.children}</Root>;
  }
}

export default VerticallyAlignedContainer;
